var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isModalVisible,
          expression: "isModalVisible"
        }
      ]
    },
    [
      _c("transition", { attrs: { name: "slide" } }, [
        _c("div", { staticClass: "modal-mask", on: { click: _vm.hide } }, [
          _c(
            "div",
            {
              staticClass: "modal-dialog modal-dialog-slideout modal-lg",
              staticStyle: { "max-width": "100%" },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                }
              }
            },
            [
              _c("div", { staticClass: "modal-content p-2" }, [
                _c("div", { staticClass: "modal-header px-4 pt-2 pb-0" }, [
                  _c("div", { staticStyle: { width: "100%" } }, [
                    _c(
                      "a",
                      {
                        staticClass: "text-uppercase text-muted pt-1",
                        attrs: { href: "javascript:void(0);" },
                        on: { click: _vm.hide }
                      },
                      [
                        _c("img", {
                          staticClass: "back_icon mr-2",
                          attrs: {
                            src: require("@/assets/manager/back_button_icon.png")
                          }
                        }),
                        _vm._v("Back")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "close float-right",
                        attrs: { type: "button" },
                        on: { click: _vm.hide }
                      },
                      [
                        _c("span", { attrs: { "aria-hidden": "true" } }, [
                          _vm._v("×")
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "clearfix" })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c("div", { staticClass: "modal_reps_to_review d-none-" }, [
                    _c("div", { staticClass: "row mb-2 mt-0" }, [
                      _c("div", { staticClass: "col-6 pl-4" }, [
                        _c(
                          "div",
                          { staticClass: "text-uppercase font-weight-bold" },
                          [_vm._v("Add Other Skills")]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-6 pr-4 text-right" })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col" }, [
                      _c("div", { staticClass: "row mb-2 mt-3" }, [
                        _c("div", { staticClass: "col-8 pl-2 pl-xl-4" }, [
                          _c(
                            "div",
                            { staticClass: "text-muted font-weight-bold" },
                            [_vm._v(_vm._s(_vm.taskListName))]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-5 px-2 px-xl-4" }, [
                          _c(
                            "div",
                            { staticClass: "input-group hours_textbox" },
                            [
                              _c("fieldset", [
                                _c("legend", [_vm._v("Hours")]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "input-group-prepend float-left col-4 p-0"
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "input-group-text bg-white",
                                        staticStyle: { padding: "4px 5px" }
                                      },
                                      [
                                        _c("img", {
                                          staticClass: "rep_time_icon",
                                          class: _vm.clockIconPositionClass,
                                          attrs: {
                                            src: require("@/assets/manager/repetition_time.png")
                                          }
                                        })
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required",
                                      expression: "'required'"
                                    },
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.timeOnTask,
                                      expression: "timeOnTask"
                                    }
                                  ],
                                  staticClass:
                                    "form-control float-left col-7 p-0 text-muted text-right pr-2",
                                  staticStyle: {
                                    "margin-top": "-6px !important",
                                    "text-align": "left !important",
                                    "padding-left": "50px !important"
                                  },
                                  attrs: {
                                    type: "number",
                                    step: "0.1",
                                    min: "0",
                                    placeholder: "",
                                    name: "timeOnTask"
                                  },
                                  domProps: { value: _vm.timeOnTask },
                                  on: {
                                    input: [
                                      function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.timeOnTask = $event.target.value
                                      },
                                      function($event) {
                                        $event.preventDefault()
                                        return _vm.checkTimeOnTaskInput($event)
                                      },
                                      function($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "blur",
                                            undefined,
                                            $event.key,
                                            undefined
                                          )
                                        ) {
                                          return null
                                        }
                                        return _vm.checkfloatCount($event)
                                      }
                                    ]
                                  }
                                })
                              ])
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-4 px-2 px-xl-4" }, [
                          _vm._v("\n                     \n                  ")
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-3 px-2 px-xl-4 text-center" },
                          [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "btn btn-primary rounded-pill border-0 text-white approve_btn d-block",
                                class: { disabled: _vm.submitDone },
                                on: {
                                  click: function($event) {
                                    return _vm.onSubmit()
                                  }
                                }
                              },
                              [_vm._v("Submit")]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "mr-2 d-block",
                                on: {
                                  click: function($event) {
                                    return _vm.hide()
                                  }
                                }
                              },
                              [_vm._v("Close")]
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "row align-items-end mb-4",
                          staticStyle: { "margin-top": "0px" }
                        },
                        [
                          _c("div", { staticClass: "col-5 px-2 px-xl-4" }, [
                            _vm.verrors.first("timeOnTask")
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "validate-warning-msg text-left"
                                  },
                                  [_vm._v("Hours is required")]
                                )
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-7 px-2 px-xl-4" })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "row align-items-end",
                          staticStyle: {
                            "margin-top": "10px",
                            "padding-right": "5px !important"
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "col-10 pr-0 col-xl-11 pr-xl-1",
                              staticStyle: { "padding-left": "25px !important" }
                            },
                            [
                              _c("textarea", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.comments,
                                    expression: "comments"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  }
                                ],
                                staticClass: "form-control text-muted",
                                attrs: {
                                  name: "comments",
                                  rows: "3",
                                  placeholder:
                                    "Give yourself credit for work and time that are NOT on your task list. Describe the work done.",
                                  maxLength: "180"
                                },
                                domProps: { value: _vm.comments },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.comments = $event.target.value
                                  }
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-2 pl-0 pr-3 col-xl-1 px-xl-0 text-right text-muted",
                              staticStyle: {
                                "padding-right": "25px !important"
                              }
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(this.comments.length) +
                                  "/" +
                                  _vm._s(this.characterLimit) +
                                  "\n                  "
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "row align-items-end mb-4" }, [
                        _c("div", { staticClass: "col-5 px-2 px-xl-4" }, [
                          _vm.verrors.first("comments")
                            ? _c(
                                "div",
                                {
                                  staticClass: "validate-warning-msg text-left"
                                },
                                [_vm._v("Comment is required")]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-7 px-2 px-xl-4" })
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" })
              ])
            ]
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2ee5a728", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ee5a728","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/manager/mentee_tasklist_add_othertask_modal.vue
// module id = null
// module chunks = 